module.exports = __webpack_public_path__ + "img/icon-corridor.bfa294ac.svg";